export default __webpack_public_path__ + "static/media/SPEKTRA_PROSPECTUS_optimize.bd485b0c.pdf";